import { groupBy } from 'lodash'
import { formatDate } from '@/utils/helpers'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import dayjs from 'dayjs'

dayjs.extend(isSameOrAfter)

const helpers = {
    buildRoutes: (accountId, audienceId) => {
        const route = '/audience_admin/data_transfers.json'
        let _params = {
            params: {
                list_limit: 0,
                conditions: { account_id: accountId, status: [{ '!=': 'deleted' }] }
            }
        }
        if (audienceId) {
            _params = {
                ..._params,
                params: { ..._params.params, conditions: { ..._params.params.conditions, audience_id: audienceId } }
            }
        }

        return { route, _params }
    },

    parseData: (data, getters, isUpdating) => {
        let _data = []
        for (const val of data) {
            // -- status should be short term solution -- \\
            const now = dayjs()
            const endDate = dayjs(val.end_date)

            _data = [
                ..._data,
                {
                    ...val,
                    status: now.isAfter(endDate, 'day') ? 'inactive' : 'active',
                    createdAt: formatDate(val.created_at, true, true),
                    endDate: formatDate(val.end_date),
                    audienceLabel: getters.getAudienceLabel({ audience_id: val.audience_id }),
                    audienceInfo:  getters.getAudienceInfos({ audience_id: val.audience_id }),
                    partner: getters.getDspLabel({ dspId: val.dsp_id }),
                    partnerConfiguration: getters.getAccountDspLabel({ accountsDspId: val.accounts_dsp_id }),
                    type: 'transfer'
                }
            ]
        }
        return isUpdating ? _data : groupBy(_data, 'audience_id')
    }
}

export default helpers
